/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import Close from '../../component/button/Close';
import {
  StyledBox,
  StyledClose,
  StyledHeader,
  StyledIcon,
  StyledMessage,
  StyledTitle,
} from './style';

/**
 * Toast (Thank you) - element 出力します
 * - widget 最後に表示します
 * - disagree の時は `message` を表示しません
 * @param {string} title title 文字列
 * @param {function} onClick `close` action を trigger します
 * @param {string} message title 下文章 - disagree の時は表示しません
 * @param {string} [className=null] wrapper container に付与する class name - 何に使用しているか不明
 * @return {*} React.node `thanks message` を返します
 * @constructor
 */
const Thanks = ({ title, onClick, message = '', className = null }) => (
  <StyledBox className={`Thanks ${className}`}>
    <StyledHeader>
      <StyledIcon />
      <StyledTitle>{title}</StyledTitle>
      <StyledClose>
        <Close onClick={onClick} color="red" id={'Thanks-close-button'} />
      </StyledClose>
    </StyledHeader>
    {message !== '' && <StyledMessage>{message}</StyledMessage>}
  </StyledBox>
);

// Thanks.propTypes = {
//   title: PropTypes.string.isRequired,
//   message: PropTypes.string,
//   className: PropTypes.string,
// };
//
// Thanks.defaultProps = {
//   message: '',
//   className: null,
// };

export default Thanks;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/thanks/Thanks.js